module.exports = __webpack_public_path__ + "static/media/4.a25e64ee.png";